/**
 * Digitize access matrix (ABDP → eVault), per product decision:
 * - Originator: view + classify / extract / validate (VA mutate)
 * - Provider / Custodian / Investor: read-only Digitize (no classify or extract)
 * - Uploader (ABDP Admin): blocked from Digitize view
 */

const VIEW_ROLES = new Set(['originator', 'provider', 'custodian', 'investor']);
const MUTATE_ROLES = new Set(['originator']);

export function canViewDigitize(role) {
  return VIEW_ROLES.has(String(role || '').trim().toLowerCase());
}

export function canMutateDigitizeVa(role) {
  return MUTATE_ROLES.has(String(role || '').trim().toLowerCase());
}

export function digitizeDeniedMessage(role) {
  const normalized = String(role || '').trim().toLowerCase();
  if (normalized === 'uploader') {
    return 'Upload-only users cannot view Digitize documents.';
  }
  return 'Digitize view requires Originator, Provider, Custodian, or Investor role.';
}
